function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.75 17.5997C20.2796 17.5997 23.15 20.4701 23.15 23.9997H21.55C21.55 21.3533 19.3964 19.1997 16.75 19.1997H7.15C4.5036 19.1997 2.35 21.3533 2.35 23.9997H0.75C0.75 20.4701 3.6204 17.5997 7.15 17.5997H16.75ZM12.366 0C15.6652 0 18.35 2.6832 18.35 5.984V10.016C18.35 13.3152 15.6652 16 12.366 16H11.534C8.2348 16 5.55 13.3152 5.55 10.016V5.984C5.55 2.6832 8.2348 0 11.534 0H12.366ZM12.366 1.6H11.534C9.1164 1.6 7.15 3.5664 7.15 5.984V10.016C7.15 12.432 9.1164 14.4 11.534 14.4H12.366C14.7836 14.4 16.75 12.432 16.75 10.016V5.984C16.75 3.5664 14.7836 1.6 12.366 1.6Z",
  fill: "currentColor"
});

var SvgAvatarLargerIcon = function SvgAvatarLargerIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatarLargerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AvatarLargerIcon.ba35114b.svg";
export { ForwardRef as ReactComponent };